import styled from 'styled-components';
import { useState } from 'react';

const TooltipContainer = styled.div`
  position: relative;
  display: block;
  width: 100%;
`;

const TooltipText = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.main.white};
  line-height: 1.5;
  word-break: break-word;
`;

const TooltipContent = styled.div`
  visibility: ${props => (props.show ? 'visible' : 'hidden')};
  opacity: ${props => (props.show ? '1' : '0')};
  background-color: #353a46;
  color: white;
  text-align: center;
  border-radius: 6px;
  padding: 8px 12px;
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: max-content;
  max-width: 200px;
  transition: opacity 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  @media (max-width: 600px) {
    max-width: 150px;
    font-size: 11px;
  }
`;

const CardHelpTooltip = ({ enabled = false, text = '', children, onMouseEnter, onMouseLeave }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  if (!enabled || !text) {
    return children;
  }

  const handleMouseEnter = () => {
    setShowTooltip(true);
    onMouseEnter?.();
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
    onMouseLeave?.();
  };

  return (
    <TooltipContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <TooltipContent show={showTooltip}>
        <TooltipText>{text}</TooltipText>
      </TooltipContent>
      {children}
    </TooltipContainer>
  );
};

export default CardHelpTooltip;
